import $ from '../zepto_1.2.0';
import { getImageUrl } from '../image-utils';
import { MenuType } from '../../types/global';

enum TEMPLATE {
  BEAUTY = 'beauty',
}
const filterArticleTag = (htmlString: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  // filter invalid tag
  function traverse(node) {
    node.children().each(function() {
      if (this.nodeType === 1 && !/^[a-zA-Z][a-zA-Z0-9-_]*$/.test(this.tagName)) {
        $(this).remove();
      } else if (this.nodeType === 1) {
        traverse($(this));
      }
    });
  }
  traverse(dom);
  // filter all style tag
  dom.find('*').removeAttr('style');
  // 移除模板类文章的数据标签
  let isBeauty = false;
  const template = dom.find('script[type="text/x.sharee.template"]');
  if (template[0]) {
    const tempType = template[0].attributes['data-type'].nodeValue;
    if (tempType === TEMPLATE.BEAUTY) {
      isBeauty = true;
    }
  }
  dom.find('script[type="text/x.sharee.template"]').remove();
  const $article = dom.find('article');
  let content = ``;
  if (isBeauty) {
    const beauty = dom.find('div[class="template-info beauty"]');
    $(`<div class="menu-list"></div>`).insertAfter(beauty[0]);
  }
  if ($article[0]) {
    let newString = $article[0].innerHTML;
    if (!isBeauty && newString) {
      newString = `<div class="menu-list"></div>${newString}`;
    }
    content = `<article>${newString || ''}</article>`;
  } else {
    let newString = dom.html();
    if (!isBeauty && newString) {
      newString = `<div class="menu-list"></div>${newString}`;
    }
    content = `<article>${newString || ''}</article>`;
  }

  return content;
};

const draftToDetail = (htmlString: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  // 将draft中的文本结构 bytedance.image 转成 a 标签
  // 因为draft中才会存在这种script 标签 type 为 bytedance.image，所以可以直接过滤
  const images = dom.find('script[type="text/x.bytedance.image"]');
  images.each((index: number, image: any) => {
    const config = JSON.parse(image.textContent);
    const {
      height,
      web_uri: webUri,
      description,
      width,
      content_url: contentUrl = '',
    } = config;
    // 如果有图片描述文案，先增加描述文案，这里的模板和服务端full接口下发对齐
    if (description) {
      $(`<div class="figcaption">${description}</div>`).insertAfter(image);
    }
    const aspectRatio = height / width || 0.5625;
    const div = document.createElement('div');
    div.className = 'image-container';

    let originSrc = `http:${getImageUrl(webUri, 'large')}`;
    let thumbSrc = `http:${getImageUrl(webUri, 'thumb')}`;
    // 兜底bad case，客户端编辑器，如果用户强行复制进来的图片不会解析为站内地址
    // 这里做兜底逻辑处理；以后会修复编辑器，该类型不复存在；以后写业务不用做这种兜底  2020.06.22 likun.liyuk
    if (!webUri && contentUrl.startsWith('http')) {
      originSrc = contentUrl;
      thumbSrc = contentUrl;
    }
    div.innerHTML = `<div class="image" ${
      contentUrl ? `content_url=${contentUrl}` : ''
    } origin_src="${originSrc}" thumb_src="${thumbSrc}" width="${width}" height="${height}" style="padding-bottom:${100 *
      aspectRatio}%"><span class="i-holder"></span><span class="t-holder">[Click to view the picture]</span></div>`;

    image.parentElement.replaceChild(div, image);
  });
  return dom.html();
};

// 对搜图片的缩放问题进行统一处理
const adaptiveImageSize = (htmlString: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  const images = dom.find('.image-container');
  images.each((index: number, image: any) => {
    const $image = $(image);
    const $elementAfterImage = $($image[0].nextElementSibling) || [];
    const imageCaption =
      $elementAfterImage[0] && $elementAfterImage[0].className === 'figcaption'
        ? $elementAfterImage[0].innerText
        : '';
    const $innerImage = $image.find('.image');
    const width = $innerImage.attr('width');

    const div = document.createElement('div');
    div.className = 'image-container';
    div.setAttribute('data-caption', imageCaption);

    // 如果图片宽小于屏幕一半，375/2（这里是移动端宽）
    if (width) {
      if (width && Number(width) <= 187.5) {
        // 这里的+32是因为盒模型原因
        div.style.width = `${Number(width) + 32}px`;
      } else {
        div.style.width = `100%`;
      }
    }

    // 这里为了CSR和SSR同构，需要把 a class="image" 里面的内容清空，便于react生成内部结构
    $image.find('span').each((i2: number, span: any) => {
      $(span).replaceWith('');
    });
    $image.find('.image-share-btn').each((i3: number, span: any) => {
      $(span).replaceWith('');
    });

    div.innerHTML = $image.html();
    image.parentElement.replaceChild(div, image);
  });
  return dom.html();
};

const menuDecorator = (htmlString: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  const headerNames = ['h1', 'h2', 'h3'];
  headerNames.forEach(headerName => {
    const headerList = dom.find(headerName);
    headerList.forEach((header, index) => {
      const span = document.createElement('span');
      span.innerText = header.innerText;
      span.setAttribute('id', `${headerName}-${index}`);
      // header.setAttribute('id', `${headerName}-${index}`);
      header.setAttribute('data-text', header.innerText);
      header.innerHTML = `${span.outerHTML}`;
    });
  });
  return dom.html();
};

const processPoiAnchorTags = (htmlString: string, countryRegion: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  const poiAnchors = dom.find('.l8editor-poi');
  poiAnchors.each((index: number, poi: HTMLAnchorElement) => {
    const $poi = $(poi);
    const poiId = $poi.data('id');
    const region = countryRegion || $poi.data('region');
    const poiPath = `/poi/${poiId}?region=${region}`;
    $poi.attr('href', poiPath);
  });

  return dom.html();
}

const processHashtagTags = (htmlString: string, countryRegion: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  const hashtagAnchors = dom.find('.l8editor-forum');
  hashtagAnchors.each((index: number, hashtag: HTMLAnchorElement) => {
    const $hashtag = $(hashtag);
    const hashtagId = $hashtag.data('id');
    const region = countryRegion || $hashtag.data('region');
    const hashtagPath = `/topic/${hashtagId}?region=${region}`;
    $hashtag.attr('href', hashtagPath);
    // 处理英文火山翻译时bug问题
    const originalText = $hashtag.text();
    const filterdText = `#${originalText.replaceAll('#', '').trim()}`;
    $hashtag.text(filterdText);
  });

  return dom.html();
}

const processSearchTags = (htmlString: string, countryRegion: string) => {
  const dom = $(`<div>${htmlString}</div>`);
  const searchAnchors = dom.find('.l8-entity-word');
  searchAnchors.each((index: number, word: HTMLAnchorElement) => {
    const $searchWord = $(word);
    const name = $searchWord.data('name');
    const region = countryRegion;
    const discoverPath = `/discover/${name}?region=${region}`;
    $searchWord.attr('href', discoverPath);
  });

  return dom.html();
}

const processSpecialTags = (htmlString: string) => {
  // const result = htmlString;
  // result = htmlString.replace(/<p><br><\/p>/g, '<p class="br"></p>');
  // 处理ins卡片相关的内容
  const dom = $(`<div>${htmlString}</div>`);
  const inses = dom.find('.ins-container');
  inses.each((index: number, ins: any) => {
    const $ins = $(ins);

    const width = $ins.data('width') || 1;
    const height = $ins.data('height') || 1;
    // ins的iframe缩放时header 54px和footer 44px不变
    const insUnresizeHeight = 54 + 44;
    // 如果没有宽高，那么默认1:1
    const ratio = (height - insUnresizeHeight) / width;
    const div = document.createElement('div');
    div.className = 'ins-container';
    // 透传结构数据，以便落地业务侧有调整
    div.dataset.width = width;
    div.dataset.height = height;

    $ins.find('iframe').each((i: number, iframe: any) => {
      iframe.removeAttribute('style');
      iframe.height = `${Math.floor(345 * ratio) + insUnresizeHeight}`;
    });

    div.innerHTML = $ins.html().replace('style=""', '');

    ins.parentElement.replaceChild(div, ins);
  });

  // 处理poi卡片相关内容

  return dom.html();
};
const processTitle = (htmlString: string, isShow: boolean) => {
  const dom = $(`<div>${htmlString}</div>`);
  let menuList: MenuType[] = [];
  let menuTopLevel = 'h3';
  const headerList = dom.find('h1,h2,h3');
  headerList.forEach(header => {
    const text = header.attributes['data-text'].value;
    if (
      // wap在正文展示目录（isShow）目录要求删除标题为空的标题，条件为当前node的type（h1,h2,h3）比menuTopLevel小，以及text不为空
      // app端保持原逻辑，没有此要求，条件为当前node的type（h1,h2,h3）比menuTopLevel小
      (header.localName < menuTopLevel && !isShow) ||
      (isShow && header.localName < menuTopLevel && text.trim())
    ) {
      menuTopLevel = header.localName;
      if (isShow) {
        menuList = [];
      }
    }
    // 兼容APP旧逻辑，等统一修改完成后去除isShow
    if ((isShow && text.trim()) || !isShow) {
      menuList.push({
        id: header.children[0].attributes.id.value,
        // 暂时标题里只有文字可以这么拼接，之后估计得调整
        text,
        type: header.localName,
        top: 0,
        pid: 'h0',
        level: 1,
      });
    }
  });
  if (!isShow) {
    menuList = menuList.filter(menu => menu.type === menuTopLevel && menu.text);
  }
  return menuList;
};

export const ProcessDetail = {
  processSpecialTags,
  processPoiAnchorTags,
  processHashtagTags,
  processSearchTags,
  filterArticleTag,
  draftToDetail,
  adaptiveImageSize,
  menuDecorator,
  processTitle,
};
